import React from 'react';
import { useRecoilState } from 'recoil';
import { getRecoil } from 'recoil-nexus';
import { useNavigate } from 'react-router-dom';
import { Flex, Grid } from 'antd';
import { switchLanguage, translateThis } from '../../helpers/language.helper';
import { appConfigAtomState } from '../../state/reducerAtoms/app.atom';
import './index.scss';
import AppPopOverMenu from '../appPopOverMenu';
import SVGIcons from '../../assets/images/icons/svgIcons';
import LogoutButton from '../buttons/logout.button';
import { useAuth } from '../../contexts/auth-context';

const HeaderRightUserInfo = () => {
    const { auth } = useAuth();
    const { firstName = '', lastName = '', email = '' } = auth || {};
    const navigate = useNavigate();

    const appState = getRecoil(appConfigAtomState);
    const profile = appState?.profile || {};
    console.log('profile', profile);
    const navigator = useNavigate();
    // const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
    const [myPortalInitialState, setMyPortalState] = useRecoilState(appConfigAtomState);

    const screenBreakpoint = Grid.useBreakpoint();

    /**
     * Invokes when drawer open
     * @returns Fun
     */
    const switchDarkMode = async () => setMyPortalState((prv) => {
        let classToAdd = 'dark-bg';
        if (prv.isDarkModeOn) {
            classToAdd = 'light-mode';
        }
        document.body.classList.remove('light-mode', 'dark-bg');
        document.body.classList.add(classToAdd);
        return { ...prv, ...{ isDarkModeOn: !prv.isDarkModeOn } }
    });

    return (
        <>
            {/* {profile ?  */}
            <div className='header-basic-info stud-profile-wrp'>
                <Flex justify={'space-between'} align={'center'} gap={'5px'} style={{ marginRight: '20px', flexDirection: 'row-reverse' }} className='language-box'>
                    <AppPopOverMenu
                        icon={SVGIcons.GlobalIcon()}
                        options={[
                            {
                                label: `${translateThis('English')}`,
                                onClick: () => switchLanguage('en')
                            },
                            {
                                label: `${translateThis('Spanish')}`,
                                onClick: () => switchLanguage('es')
                            },
                        ]}
                    />
                    <p>{myPortalInitialState.selectedLang === 'en' ? `${translateThis('English')}` : `${translateThis('Spanish')}`}</p>
                </Flex>

                {screenBreakpoint.lg ? <>
                    {profile?.profileImg?.tempURL && <span className='profile-img'><img src={profile?.profileImg?.tempURL} alt={profile?.name} /></span>}
                    <div className='header-basic-con'>
                        <h4>{profile?.name}</h4>
                        <p>{profile?.email}</p>
                    </div> </> : null}
                <AppPopOverMenu
                    className='stud-popup'
                    icon={<SVGIcons.MenuIcon />}

                    options={[
                        // {
                        //     label: <span className='stud-menu'>{SVGIcons.ProfileIcon()} {translateThis('Profile')}</span>,
                        //     onClick: () => navigate(`/profile`)
                        // },
                        {
                            label: <span className='stud-menu logout'>{SVGIcons.LogoutIcon()} {<LogoutButton />}</span>,
                            onClick: () => { console.log('logout') }
                        },
                    ]
                    }

                />
            </div>
            {/* : null} */}
            {/* {openDeleteDialog && <ConfirmDialog
                isOpen={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                }}
                title="Confirm logout"
                className={'delete-popup logout-popup'}
                description={<span>Are you sure you want to logout?</span>}
                okayButtonText={'Logout'}
                onConfirm={() => logoutUser('Logged out successfully!')}
            />} */}

        </>
    );
}

export default HeaderRightUserInfo;
